<template>
  <div class="automation-badge">
    <Badge
      :severity="displayEnabled ? 'success' : 'secondary'"
      :value="displayEnabled ? 'Automation Enabled' : 'Automation Disabled'"
    />
    <span v-if="sellerHint" class="automation-badge-hint"
      >since 0 active sellers</span
    >
  </div>
</template>

<script setup>
import { computed } from "vue";
import Badge from "primevue/badge";

// eslint-disable-next-line no-undef
const props = defineProps({
  enabled: { type: Boolean, default: false },
  activeSellerCount: { type: Number, default: 0 },
});

const displayEnabled = computed(
  () => props.enabled && props.activeSellerCount > 0
);
const sellerHint = computed(
  () => props.enabled && props.activeSellerCount === 0
);
</script>

<style scoped>
.automation-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.automation-badge :deep(.p-badge) {
  height: auto;
  width: auto;
  white-space: nowrap;
  padding: 0.1rem 0.35rem;
  font-size: 0.63rem;
}

.automation-badge-hint {
  font-size: 0.7rem;
  color: var(--text-color-secondary);
  white-space: nowrap;
}
</style>
